// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___vy7D","left":"styles_left__3kMrx","right":"styles_right__2YU7I","alert":"styles_alert__1PVso"};